import { render, staticRenderFns } from "./CaseNumberRatio.vue?vue&type=template&id=48a988d1&scoped=true"
import script from "./CaseNumberRatio.vue?vue&type=script&lang=js"
export * from "./CaseNumberRatio.vue?vue&type=script&lang=js"
import style0 from "./CaseNumberRatio.vue?vue&type=style&index=0&id=48a988d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a988d1",
  null
  
)

export default component.exports